import React, { useState, useEffect } from 'react';
import { Button } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import styles from '../styles';
import EditConfirmDialog from './EditConfirmDialog';
import { updateAttribute } from '../../../redux/actions/focusedAttributeActions';

const EditSubmit = ({
  attribute,
  disabled,
  handleSubmit,
  prepareData,
  setContainingModalVisibility,
}) => {
  const [openConfirmDialog, setOpenConfirmDialog] = useState(false);

  useEffect(() => {
    setContainingModalVisibility(!openConfirmDialog);
  }, [setContainingModalVisibility, openConfirmDialog]);

  const classes = styles();
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const handleFormSubmit = data => {
    const attribute = prepareData(data);
    dispatch(updateAttribute(attribute));
    setOpenConfirmDialog(false);
  };

  const handleModalClose = reason => {
    if (['backdropClick', 'escapeKeyDown'].includes(reason)) return;
    setOpenConfirmDialog(false);
  };

  return (
    <>
      <Button
        variant="outlined"
        className={disabled ? '' : classes.buttonStyleBlack}
        disabled={disabled}
        style={{ marginLeft: '5px' }}
        onClick={() => setOpenConfirmDialog(true)}
        data-testid="submit-button"
      >
        {t('attributes.button.submit')}
      </Button>
      <EditConfirmDialog
        open={openConfirmDialog}
        onClose={handleModalClose}
        attribute={attribute}
        onSubmit={handleSubmit(handleFormSubmit)}
      />
    </>
  );
};

export default EditSubmit;
